import React, {ReactElement} from 'react';
import CustomPopOver, {
  CustomPopOverListItemType
} from '../CustomPopOver/CustomPopOver';
import {IconButton, PopperPlacementType, makeStyles} from '@material-ui/core';
import {APP_PRIMARY_COLOR} from 'src/style/variable';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
interface LinkDropdownProps {
  title: string;
  listItems: Array<CustomPopOverListItemType>;
  handleItemClick: (
    value: string | any,
    event?: React.MouseEvent<EventTarget>
  ) => void;
  position?: PopperPlacementType;
  prefixIcon?: JSX.Element;
  enablePortal?: boolean;
}

const useStyles = makeStyles(() => ({
  Parentlink: {
    flexDirection: 'row-reverse',
    paddingTop: '0rem'
  },
  actionItemButtons: {
    padding: '0.25rem',
    width: '25px',
    color: APP_PRIMARY_COLOR
  },
  styleWrapper: {
    alignItems: 'center',
    padding: 0
  },
  changeToLink: {
    whiteSpace: 'nowrap'
  }
}));
const LinkDropdown = (props: LinkDropdownProps): ReactElement => {
  const {
    title,
    listItems,
    handleItemClick,
    position = 'right-start',
    enablePortal,
    prefixIcon = <KeyboardArrowDownIcon style={{color: APP_PRIMARY_COLOR}} />
  } = props;
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div
      className={
        position === 'right-start'
          ? ['link-style', classes.Parentlink, classes.styleWrapper].join(' ')
          : ['link-style', classes.styleWrapper].join(' ')
      }
      onClick={handleClick}>
      <div className={classes.changeToLink}>
        {position !== 'right-start' && (
          <IconButton
            className={['custom-icon-button', classes.actionItemButtons].join(' ')}
          >
            {prefixIcon}
          </IconButton>
        )}
        {title}
        {position === 'right-start' && (
          <IconButton
            className={['custom-icon-button', classes.actionItemButtons].join(' ')}
          >
            {prefixIcon}
          </IconButton>
        )}
      </div>
      <CustomPopOver
        open={open}
        listItems={listItems}
        anchorEl={anchorEl || null}
        position={position}
        handleClose={handleClose}
        handleListItemClick={(item: any, ev) => {
          handleItemClick(item);
          ev?.stopPropagation();
          handleClose();
        }}
        enablePortal={enablePortal}
      />
    </div>
  );
};
export default LinkDropdown;
